export default "__VITE_ASSET__BkDHjue7__"